import React, {useEffect} from "react"
import { useLocation } from 'react-router-dom';
import ReactGA from 'react-ga';
import {useNavigate} from 'react-router-dom'
import {Helmet} from "react-helmet";
import CustomCarousel from "../../components/Carousel"
import PhoneNumber from "../../components/phone-number"
import { RoutePaths } from "../../constant";
import ProductInfo from '../../components/productInfo'
import Partners from "../../components/partners";
import Services from "../../components/services"
import ServicesOffered from '../../components/ServicesOffered'

import "./../../common/css/global.css";
import "./home.css"

const Home = ()=> {
    const navigate = useNavigate();
    const location = useLocation();
    
    const navigateToServices = () => {
        navigate(RoutePaths.services);
      };
    return (
        <>
        <Helmet>
            <title>Hyderabad ambulance service | Bhavya Ambulance</title>
            <meta name="description" content="Hyderabad Ambulance Services, Rapid Response, Expert Care. Trust us for swift and professional ambulance assistance in Hyderabad. Available 24/7 for your emergency medical needs." />
            <meta name="keywords" content="Hyderabad Ambulance service" />
        </Helmet>
        <PhoneNumber isSticky />
        <div className="sticky-page">
            <h1 style={{display: "none"}}>Fastest Ambulance Services in Hyderabad - Bhavya Ambulance</h1>
            <CustomCarousel />
            <div className="component-layout">
                <Partners />
                <ProductInfo
                    title= 'access to the right emergency'
                    highlightTitle="Immediate"
                    subTitle='Reliable Ambulance Services Near You in Hyderabad'
                    image='images/patient-in-ambulance.svg'
                    description="Bhavya Ambulance, the best Hyderabad ambulance service near me, provides prompt and dependable emergency medical transportation. We ensure fast assistance at critical moments by deploying a dedicated staff and cutting-edge vehicles. In times of need, you can count on us for compassionate care and dependable support throughout the city."
                    buttonText="Read More..."
                />
                <ProductInfo
                    title= 'highly trained professionals'
                    highlightTitle="Staffed by"
                    subTitle='Our Comprehensive Range of Services and Facilities'
                    image='images/service-crew.png'
                    description="Bhavya Ambulance Services in Hyderabad offers a comprehensive range of options, including Advanced Life Support (ALS), Basic Life Support (BLS)..."
                    buttonText="Read More..."
                    flipProduct
                />
                <ProductInfo
                    title= 'medical support during transport'
                    highlightTitle="Intensive"
                    subTitle='Critical Care and ICU Ventilator Ambulance Services in Hyderabad'
                    image='images/patient-service.png'
                    description="In addition to our standard services, Bhavya Ambulance Services offers critical care and ventilator ambulance services in Hyderabad"
                    buttonText="Read More..."
                />
                <Services />
                <ServicesOffered />
            </div>
        </div>
        </>
    )
}

export default Home;